module.exports = __webpack_public_path__ + "static/img/xwf.e0b9c28.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/xwf.png
// module id = UFiL
// module chunks = 0